var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1322,
    height: 234,
    viewBox: "0 0 1322 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 9.30403C-872.824 9.30403 -408.753 -4.83635 -289.019 -54.3277C-174.508 -101.771 297.198 -114.523 297.198 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 33.0916C-872.824 33.0916 -303.483 16.7707 -156.828 -42.9625C-17.0043 -99.9866 561.176 -114.523 561.176 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 56.9452C-872.824 56.9452 -198.615 38.3777 -25.0404 -31.4652C140.498 -98.2686 825.154 -114.523 825.154 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 80.7328C-872.824 80.7328 -93.3452 59.9848 107.15 -20.1C298.002 -96.4845 1089.13 -114.523 1089.13 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 104.52C-872.824 104.52 11.9248 81.5918 239.34 -8.66879C455.505 -94.7005 1352.71 -114.523 1352.71 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 128.374C-872.824 128.374 116.793 103.265 371.128 2.76247C613.409 -92.9825 1616.69 -114.523 1616.69 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 152.162C-872.824 152.162 222.062 124.806 503.318 14.1937C770.912 -91.1984 1880.67 -114.523 1880.67 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 175.949C-872.824 175.949 327.332 146.413 635.106 25.5589C928.415 -89.4143 2144.64 -114.523 2144.64 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 199.803C-872.824 199.803 432.2 168.086 767.296 37.0562C1085.92 -87.6964 2408.22 -114.523 2408.22 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 223.59C-872.824 223.59 537.47 189.693 899.084 48.4875C1243.42 -85.9123 2672.2 -114.523 2672.2 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 247.444C-872.824 247.444 642.74 211.3 1031.27 59.9187C1400.92 -84.1282 2936.18 -114.523 2936.18 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 271.231C-872.824 271.231 747.608 232.907 1163.06 71.3499C1558.43 -82.4102 3200.15 -114.523 3200.15 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 295.019C-872.824 295.019 852.878 254.514 1295.25 82.7151C1715.93 -80.6262 3464.13 -114.523 3464.13 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 318.873C-872.824 318.873 958.148 276.121 1427.44 94.2124C1873.43 -78.8421 3727.71 -114.523 3727.71 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 342.66C-872.824 342.66 1063.02 297.728 1559.23 105.578C2030.94 -77.1241 3991.69 -114.523 3991.69 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 366.448C-872.824 366.448 1168.29 319.335 1691.42 117.009C2188.44 -75.34 4255.67 -114.523 4255.67 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 390.302C-872.824 390.302 1273.56 341.008 1823.21 128.44C2345.94 -73.556 4519.64 -114.523 4519.64 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-872.824 414.089C-872.824 414.089 1378.42 362.549 1955.4 139.871C2503.45 -71.838 4783.22 -114.523 4783.22 -114.523",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogHeaderBg);
export default __webpack_public_path__ + "static/media/blogHeaderBg.5a935c2a4d7fb18990200dc1fc9ce254.svg";
export { ForwardRef as ReactComponent };